<template>
  <div id="app">
    <NavBar />
    <router-view class="mt-5" />
    <div v-if="authorized">
      <AdminGroupsBinder />
    </div>
  </div>
</template>

<script>
import "@/fstore";
import AdminGroupsBinder from "@/components/binders/AdminGroupsBinder.vue";
import NavBar from "@/components/NavBar";
export default {
  name: "App",
  components: {
    AdminGroupsBinder,
    NavBar
  },
  data() {
    return {
      show_creation_ui: false
    };
  },
  computed: {
    authorized() {
      return this.$store.state.authorized;
    },
    auth_initialized() {
      return this.$store.state.auth_initialized;
    },
    login_check() {
      if (this.$route.meta.login_required) {
        return this.authorized;
      } else {
        return true;
      }
    }
  }
};
</script>

<style lang="scss"></style>
